module.exports = __webpack_public_path__ + "static/media/heart-white.353e9069.svg";